(() => {
  const storageKey = 'maison-la-muse-favourites';

  const readFavourites = () => {
    try { return JSON.parse(window.localStorage.getItem(storageKey) || '[]'); } catch { return []; }
  };
  const saveFavourites = (handles) => {
    try { window.localStorage.setItem(storageKey, JSON.stringify(handles)); } catch { /* Browsing remains available when storage is blocked. */ }
  };

  class ProductCard extends HTMLElement {
    connectedCallback() {
      this.dataset.touchSafe = 'true';
      this.media = this.querySelector('[data-card-media]');
      this.secondary = this.querySelector('[data-secondary-image], .product-card__image--secondary');
      if (this.secondary) this.media?.setAttribute('data-secondary-on-hover', 'true');
      this.secondaryToggle = this.querySelector('[data-card-secondary-toggle]');
      this.favourite = this.querySelector('[data-favourite]');
      this.quickAdd = this.querySelector('form[data-quick-add]');
      this.syncFavourite();
      this.secondaryToggle?.addEventListener('click', this.toggleSecondary);
      this.favourite?.addEventListener('click', this.toggleFavourite);
      this.quickAdd?.addEventListener('submit', this.submitQuickAdd);
    }

    disconnectedCallback() {
      this.secondaryToggle?.removeEventListener('click', this.toggleSecondary);
      this.favourite?.removeEventListener('click', this.toggleFavourite);
      this.quickAdd?.removeEventListener('submit', this.submitQuickAdd);
    }

    toggleSecondary = () => {
      if (!this.secondary) return;
      const next = !this.media?.hasAttribute('data-secondary-active');
      this.media?.toggleAttribute('data-secondary-active', next);
      this.secondaryToggle?.setAttribute('aria-pressed', String(next));
    };

    syncFavourite() {
      if (!this.favourite) return;
      const saved = readFavourites().includes(this.dataset.productHandle);
      this.favourite.setAttribute('aria-pressed', String(saved));
      this.favourite.setAttribute('aria-label', saved ? this.dataset.favouritedLabel : this.dataset.favouriteLabel);
    }

    toggleFavourite = () => {
      const handle = this.dataset.productHandle;
      if (!handle) return;
      const handles = new Set(readFavourites());
      if (handles.has(handle)) handles.delete(handle); else handles.add(handle);
      saveFavourites([...handles]);
      this.syncFavourite();
    };

    announce(message, isError = false) {
      const status = this.querySelector('[data-quick-add-status]');
      if (!status) return;
      status.textContent = message;
      status.hidden = false;
      status.setAttribute('role', isError ? 'alert' : 'status');
    }

    redirectToCart(url) { window.location.assign(url); }

    submitQuickAdd = async (event) => {
      event.preventDefault();
      const button = this.quickAdd?.querySelector('[type="submit"]');
      if (!this.quickAdd || !button) return;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      let addSucceeded = false;
      try {
        const response = await fetch(this.dataset.addUrl || '/cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.quickAdd)
        });
        if (!response.ok) throw new Error('Cart add failed');
        addSucceeded = true;
        await response.json().catch(() => null);
        if (this.dataset.cartMode === 'drawer') {
          const cartResponse = await fetch(this.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
          if (!cartResponse.ok) throw new Error('Cart refresh failed');
          const cart = await cartResponse.json();
          const drawer = document.getElementById('CartDrawer');
          if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.open !== 'function') throw new Error('Cart drawer unavailable');
          drawer.renderContents(cart);
          drawer.open(button);
          if (typeof drawer.announce === 'function') drawer.announce(this.dataset.quickAddSuccess);
          else throw new Error('Cart drawer status unavailable');
        } else {
          this.announce(this.dataset.quickAddSuccess);
          this.redirectToCart(this.dataset.cartUrl);
        }
      } catch {
        if (addSucceeded) this.redirectToCart(this.dataset.cartUrl);
        else this.announce(this.dataset.quickAddError, true);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    };
  }

  if (!customElements.get('product-card')) customElements.define('product-card', ProductCard);
})();
